/* eslint-disable */
import '@search/vtbeco-frontend-core/domain/boot/polyfills';

import { pkgName } from '../view/pkgName';

export const config = (window as any)[`${pkgName}_config`] || {};

declare var __webpack_public_path__: string;

__webpack_public_path__ = config.staticPath;
